import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["min", "step", "disabled"]

import { InputCustomEvent, IonCol, IonGrid, IonInput, IonRow, } from "@ionic/vue";
import { computed, ref, onMounted, onBeforeUnmount } from "vue";

import ButtonMinus from "@/components/button/ButtonMinus.vue";
import ButtonPlus from "@/components/button/ButtonPlus.vue";

import { MIN_VALUE, INITIAL_TIMER, TIMER_SUBSTRACTION, TIMER_MIN } from "@/assets/variables";

import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { InputAmountProps } from "@/types/props";
import { InputAmountEmits } from "@/types/emits";


export default /*@__PURE__*/_defineComponent({
  __name: 'InputAmount',
  props: {
    modelValue: {},
    amountStep: {},
    small: { type: Boolean },
    isReducedList: { type: Boolean },
    disabled: { type: Boolean },
    directInputDisabled: { type: Boolean },
    slim: { type: Boolean },
    preventPropagation: { type: Boolean },
    max: {},
    minValue: { default: 0 }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const amountInput = ref()
const changeTimer = ref<number>(INITIAL_TIMER)
const changeable = ref<boolean>(true)
const counterTimeout = ref<number | undefined>(0)

let preventBlur = false

const inputValue = computed<string | number>({
    get: () => {
        if (!props.modelValue) return 0
        return props.modelValue
    },
    set: async (value) => {
        // const convertedNumber = Number(value)
        const convertedNumber = Number(String(value).replace(/[^0-9]*/g, ''));

        if (isNaN(convertedNumber) || value === '' || value === '00') {
            emit('update:modelValue', props.minValue)
            amountInput.value.value = props.minValue;
            changeable.value = true
            return
        }

        if (convertedNumber < props.minValue) {
            emit('update:modelValue', props.minValue)
            amountInput.value.value = props.minValue;
            changeable.value = true
            return
        }

        if (props.max && convertedNumber > props.max) {
            emit('update:modelValue', props.max)
            amountInput.value.value = props.max;
            changeable.value = true
            return
        }

        if (!changeable.value) return
        changeable.value = false

        emit('update:modelValue', convertedNumber)
        emit('change', convertedNumber)
        amountInput.value.value = convertedNumber;

        changeable.value = true
    },
})

const handleFocus = (event: FocusEvent) => {
    if (preventBlur) {
        preventBlur = false
        return
    }
    const target = event.target as HTMLInputElement;
    target?.blur()
}

const select = (event: InputCustomEvent): void => {
    if (props.preventPropagation && event?.type === 'click') event.stopPropagation()
    if (event.target.select) { // tapped directly on html input
        preventBlur = true
        event.target.select();
    } else if (event.target.children[0].select) { // tapped on the wrapper
        preventBlur = true
        event.target.children[0].select();
    }
}

const selectValue = (event: Event): void => {
    const target = event.target as HTMLInputElement;
    preventBlur = true
    target.select();
}

const changeValue = (modifier: number, event?: MouseEvent): void => {
    if (props.preventPropagation && event?.type === "click") event.stopPropagation()
    if (!changeable.value) return
    changeable.value = false

    if (!props.modelValue) {
        if (props.modelValue === props.minValue) changeable.value = true
        emit('update:modelValue', modifier < 0 ? props.minValue : modifier)
        return
    }

    if ((Number(props.modelValue) + modifier < props.minValue && modifier < 0) || (props.max && (Number(props.modelValue) + modifier > props.max))) {
        changeable.value = true
        return
    }

    emit('update:modelValue', Number(props.modelValue) + modifier)
    changeable.value = true
}

const nextChangeTick = (modifier: number): void => {
    if (!changeable.value) return
    changeable.value = false

    counterTimeout.value = setTimeout(() => {
        changeable.value = true
        changeValue(modifier)
        if (changeTimer.value - TIMER_SUBSTRACTION >= TIMER_MIN)
            changeTimer.value -= TIMER_SUBSTRACTION
        nextChangeTick(modifier)
    }, changeTimer.value)
}

const quickChange = (modifier: number): void => {
    if (counterTimeout.value) return
    nextChangeTick(modifier)
}

const stopQuickChange = (): void => {
    clearTimeout(counterTimeout.value)
    changeable.value = true
    counterTimeout.value = undefined
    changeTimer.value = INITIAL_TIMER
}

onMounted(() => {
  document.addEventListener('mouseup', stopQuickChange)
})

onBeforeUnmount(() => {
  document.removeEventListener('mouseup', stopQuickChange)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonGrid), {
    class: _normalizeClass(["card-border", {
            'px-0': __props.isReducedList,
            'pb-0': __props.isReducedList,
            'coral-coral-background p-2 input-amount-container': !__props.isReducedList,
            slim: __props.slim
        }])
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRow), {
        onClick: [
          _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
          _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"]))
        ],
        style: {"flex-wrap":"nowrap"},
        class: "d-flex ion-justify-content-between"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), {
            class: _normalizeClass(["d-flex ion-justify-content-end", { disabled: __props.disabled, 'px-0': __props.isReducedList }]),
            size: __props.isReducedList ? '4' : undefined
          }, {
            default: _withCtx(() => [
              _createVNode(ButtonMinus, {
                class: _normalizeClass(["round-button tint-button amount-button", { disabled: __props.disabled, slim: __props.slim, 'outline-button': __props.isReducedList }]),
                color: __props.isReducedList ? _unref(ION_VARIANT).LIGHT : _unref(ION_VARIANT).CORAL,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (changeValue(-1 * (__props.amountStep ?? 1), $event))),
                onMousedown: _cache[1] || (_cache[1] = ($event: any) => (quickChange(-1 * (__props.amountStep ?? 1)))),
                onMouseup: stopQuickChange,
                onTouchstartPassive: _cache[2] || (_cache[2] = ($event: any) => (quickChange(-1 * (__props.amountStep ?? 1)))),
                onTouchendPassive: stopQuickChange,
                onContextmenu: _cache[3] || (_cache[3] = ($event: any) => ($event.stopPropagation())),
                disabled: __props.disabled
              }, null, 8, ["class", "color", "disabled"])
            ]),
            _: 1
          }, 8, ["class", "size"]),
          _createVNode(_unref(IonCol), {
            size: __props.isReducedList ? '4' : 'auto',
            class: _normalizeClass(["input-col center-y", {center: __props.isReducedList}])
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["light-light-background max-size center ion-text-center remove-padding-input amount-input amount-input-fix", {
                        small: __props.small,
                        slim: __props.slim,
                        reduced: __props.isReducedList,
                        'grey4-grey4-background': __props.isReducedList,
                        'purple-purple-color': __props.isReducedList,
                        'coral-coral-color': !__props.isReducedList
                    }]),
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (selectValue($event)), ["stop"])),
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((inputValue).value = $event)),
                min: props.minValue,
                id: "input-amount-cart",
                ref_key: "amountInput",
                ref: amountInput,
                step: String(__props.amountStep),
                inputmode: "numeric",
                type: "text",
                disabled: __props.directInputDisabled || (__props.disabled ?? false),
                onFocusin: handleFocus
              }, null, 42, _hoisted_1), [
                [
                  _vModelText,
                  inputValue.value,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _: 1
          }, 8, ["size", "class"]),
          _createVNode(_unref(IonCol), {
            class: _normalizeClass({ disabled: __props.disabled, 'px-0': __props.isReducedList }),
            size: __props.isReducedList ? '4' : undefined
          }, {
            default: _withCtx(() => [
              _createVNode(ButtonPlus, {
                class: _normalizeClass(["round-button tint-button amount-button", { disabled: __props.disabled, slim: __props.slim, 'outline-button': __props.isReducedList }]),
                color: __props.isReducedList ? _unref(ION_VARIANT).LIGHT : _unref(ION_VARIANT).CORAL,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (changeValue(__props.amountStep ?? 1, $event))),
                onMousedown: _cache[7] || (_cache[7] = ($event: any) => (quickChange(__props.amountStep ?? 1))),
                onMouseup: stopQuickChange,
                onTouchstartPassive: _cache[8] || (_cache[8] = ($event: any) => (quickChange(__props.amountStep ?? 1))),
                onTouchendPassive: stopQuickChange,
                onContextmenu: _cache[9] || (_cache[9] = ($event: any) => ($event.stopPropagation())),
                disabled: __props.disabled
              }, null, 8, ["class", "color", "disabled"])
            ]),
            _: 1
          }, 8, ["class", "size"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})